import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { setOpenSideBar } from "../redux/slices/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../redux/slices/userSlice";

const UserNavRap = styled.div`
  background: #060b130a !important;
 padding: 17px 34px;
  position: fixed;
  z-index: 9999 !important;
  top: 0;
  left: 0px;
  right: 0px;
  .userNav {
   
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .channel {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #bac0d499;
    background: #ffffff;
    border-radius: 100px;
    padding: 10px 23px;
  }
  .channel p,
  .channel span {
    margin: 0px;
    color: #363d4f;
    font-size: 14px;
    font-weight: 400;
  }
  .channel span {
    color: #ed1c24;
  }
  .upgrade {
    border: 0.7px solid #ed1c24;
    background: #ed1c2412;
    width: 146px;
    height: 40px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    color: #ed1c24;
    font-size: 14px;
    font-weight: 400;
  }
  .notification {
    background: #ffffff;
    border: 1px solid #bac0d499;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .username {
    background: #ffffff;
    height: 40px;
    width: 177px;
    border-radius: 100px;
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    border: 1px solid #BAC0D499;
  }
  .username p {
    color: #060B13;
    font-size: 14px;
    font-weight: 400;

  }
  .end-nav-user {
    display: flex;
    gap: 15px;
    align-items: center;
  }

  .open-icon-div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .open-icon-div  img {
    width: 86px;

    height: 26px;
  }
  @media (max-width: 992px) {
.userNav {
  flex-wrap: wrap;
}
  }
  @media (max-width: 480px)  {
    .channel {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 435px) {
    .end-nav-user {
      flex-wrap: wrap;
    }
  }
`;

const ListenerNav = () => {
  const {openSideBar} = useSelector((state)=> state.app)
  const dispatch =useDispatch()

    const { userData, loading, error } = useSelector((state) => state.userData);
  
  


    useEffect(() => {
      dispatch(fetchUsers());
    }, [dispatch]);

  const ShowBar = ()=> {
    dispatch(setOpenSideBar())
  }
  return (
    <UserNavRap>
      <div className="userNav">
        <div className="open-icon-div">
        <Icon className="icon-admin-menu"
                width="50px"
                height="50px"
                icon={openSideBar ? "mdi-light:menu" :"prime:times" }
                color="black"
                onClick={()=> ShowBar()}
              />
        <img src="/images/logo.png" alt="" />
        </div>
      
        
        <div className="end-nav-user">
         
          
          <div className="notification">
            <Icon
              icon="basil:notification-outline"
              width="16"
              height="16"
              style={{ color: "#363D4F", cursor: "pointer" }}
            />
          </div>
          <div className="username">
            <img src="/images/user-img.png" alt="" />
            <p>{userData?.data?.lname} {userData?.data?.fname}</p>
          </div>
        </div>
      </div>
    </UserNavRap>
  );
};

export default ListenerNav;
